<template>
  <div class="screen-7">
    <div class="container" id="technologies">
      <div class="row">
        <div class="col-12">
          <TitleWidget class="text-center">{{ $t(locale.tech.title) }}</TitleWidget>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div role="tablist" class="pt-5 d-block d-md-none">
            <div :class="'accordion-item' + ' ' + rootItem.class_string"
                 v-for="rootItem in screenSettings.accordionItems" :key="rootItem.id">
              <b-link href="#" v-b-toggle="rootItem.id" variant="info"
                      :class="'accordion-item-header d-block d-sm-inline-block transition position-relative'"
                      aria-expanded="false">
                <span>{{ $t(rootItem.head) }}</span>
                <font-awesome-icon icon="angle-down" :class="'accordion-item-header-arrow position-absolute'"/>
              </b-link>
              <b-collapse :class="'accordion-item-content expanded'" :id="rootItem.id" accordion="my-accordion"
                          role="tabpanel">
                                <span class="d-block" v-for="sub in rootItem.ul" :key="sub.id">
                                    <b>{{ sub.head }}</b>
                                </span>
                <ul class="accordion-list pt-4" v-for="sub in rootItem.ul" :key="sub.head">
                  <li v-for="li in sub.lis" :key="li.id">
                    <b>{{ li.head }}</b>&nbsp;
                    <span>{{ li.text }}</span>
                  </li>
                </ul>
              </b-collapse>
            </div>

          </div>
          <div role="tablist" class="pt-5 d-none d-md-block d-lg-flex flex-lg-column flex-lg-wrap">
            <!--start-->
            <div
                :class="'accordion-item mt-lg-0'+ ' order-' + rootItem.order + ' order-lg-' + rootItem.order_lg + ' ' + rootItem.class_string"
                v-for="rootItem in screenSettings.accordionItems" :key="rootItem.id">
                                <span :class="'accordion-item-header d-inline-block transition'">
                                    {{ $t(rootItem.head) }}
                                </span>
              <div :class="'accordion-item-content'" :id="rootItem.id" role="tabpanel">
                                    <span class="d-block" v-for="sub in rootItem.ul" :key="sub.id">
                                        <b>{{ sub.head }}</b>
                                    </span>
                <ul class="accordion-list pt-4" v-for="sub in rootItem.ul" :key="sub.head">
                  <li v-for="li in sub.lis" :key="li.id">
                    <b>{{ li.head }}</b>&nbsp;
                    <span>{{ li.text }}</span>
                  </li>
                </ul>
              </div>
            </div>
            <!--/end-->
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import "src/scss/typo";

.screen-7 {
  padding-top: 60px;
  padding-bottom: 82px;
  @media (min-width: 576px) {
    padding-top: 140px;
    padding-bottom: 140px;
  }

  .flex-lg-wrap {
    @media (min-width: 1440px) {
      display: flex;
      flex-direction: column;
      height: 760px;
    }
  }
}

.accordion-item {
  @media (min-width: 992px) {
    width: 100%;
    max-width: 600px;
  }
  @media (min-width: 1440px) {
    width: 50%;
    max-width: 563px;
  }

  .accordion-item-header {
    width: 100% !important;

    span {
      max-width: 300px;
      display: inline-block;
      @media (min-width: 430px) {
        max-width: none;
      }
    }

    .accordion-item-header-arrow {
      display: inline;
      float: right;
      font-size: 14px;
      vertical-align: middle;
      color: #00D665;
      position: absolute !important;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }

    &[aria-expanded=true] {
      .accordion-item-header-arrow {
        transform: rotate(180deg);
      }
    }

  }

  .accordion-item-content {
    &:before {
      content: '';
      margin-top: 1rem;
      display: block;
      width: 50px;
      height: 4px;
      background-color: #00D665;
      margin-bottom: 1rem;
    }

    ul {
      padding: 0 15px;
      list-style-image: url('/img/bullet.svg');
      border-bottom: 1px solid #EFEFEF;
      @media (min-width: 768px) {
        border-bottom: none;
      }
      padding-bottom: 28px;

      li {
        span {
          opacity: .7;
        }

        & + li {
          margin-top: 2rem;
        }
      }
    }
  }

  & + .accordion-item {
    margin-top: 2rem;
  }
}
</style>

<script>
import TitleWidget from "@/components/common/TitleWidget";
import stringsKeys from "@/i18n/strings.json";

export default {
  name: 'ScreenTech',
  components: {TitleWidget},
  data: () => {
    return {
      locale: stringsKeys,
      screenSettings: {
        accordionItems: [
          {
            id: "accMobile",
            head: stringsKeys.tech.mobile.title,
            ul: [{
              id: 0,
              head: 'Supported OS',
              lis: [
                {
                  id: 0,
                  head: "iOS",
                  text: 'Swift 5, Crashlytics, Fabric, Fastlane, Swiftlint, Carthage/Pods, Alamofire',
                },
                {
                  id: 1,
                  head: "Android",
                  text: 'Kotlin, Android Jetpack, Firebase, Crashlytics, RxJava, Retrofit, Dagger 2',
                },
              ]
            }],
            order: 0,
            order_lg: 0,
            class_string: '',
          },
          {
            id: "accJava",
            head: stringsKeys.tech.java.title,
            ul: [{
              id: 0,
              lis: [
                {
                  id: 0,
                  head: "Platforms",
                  text: 'Java SE, Java EE',
                },
                {
                  id: 1,
                  head: "Application servers/containers",
                  text: 'JBoss EAP, WildFly, Apache Tomcat',
                },
                {
                  id: 2,
                  head: "Database management systems",
                  text: 'Oracle DB, MS SQL Server, PostgreSQL, MySQL, MongoDB',
                },
                {
                  id: 3,
                  head: "Data access object layer",
                  text: 'JPA, Hibernate, Spring data repositories, JDBC',
                },
                {
                  id: 4,
                  head: "Business logic layer",
                  text: 'EJB, Spring IoC container (POJOs)',
                },
                {
                  id: 5,
                  head: "Presentation layer",
                  text: 'JSF, RichFaces, Spring Web MVC, jQuery UI, Bootstrap 4',
                },
                {
                  id: 6,
                  head: "Security",
                  text: 'SPNEGO, oAuth 2.0 (Spring Security OAuth)',
                },
                {
                  id: 7,
                  head: "OCR",
                },
              ]
            }],
            order: 1,
            order_lg: 1,
            class_string: '',

          },
          {
            id: "accphp",
            head: stringsKeys.tech.php.title,
            ul: [{
              id: 0,
              lis: [
                {
                  id: 0,
                  head: "Platforms",
                  text: 'PHP 7, Symfony',
                },
                {
                  id: 1,
                  head: "Database management systems",
                  text: 'PostgreSQL,MySQL',
                },
                {
                  id: 2,
                  head: "UI frameworks",
                  text: 'Bootstrap 4, JavaScript (ECMAScript 6, jQuery)',
                },
              ]
            }],
            order: 2,
            order_lg: 0,
            class_string: 'mt-lg-5_',
          },
        ],
      }
    }
  }
}
</script>
